import countries from 'i18n-iso-countries';
import deutsch from 'i18n-iso-countries/langs/de.json';
import english from 'i18n-iso-countries/langs/en.json';
import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FormTextField } from '../../../../lib/components';
import { ProfileForm, ProfileFormProps } from '../shared/profileForm';
import Util from '../../../../misc/util';
countries.registerLocale(deutsch);
countries.registerLocale(english);

type Props = Omit<ProfileFormProps, 'children'>;

export const ContactDataForm: FC<Props> = (props) => {
  const { t } = useTranslation();

  const [missingFields, setMissingFields] = useState<string[]>();

  useEffect(
    () => setMissingFields(props.formRef?.current?.values?.missing_fields),
    [props.formRef?.current?.values?.missing_fields]
  );

  return (
    <ProfileForm {...props}>
      <FormTextField
        placeholder={t('template:YOUR_PROP', {
          context: 'suffix',
          suffix: '',
          val: Util.lowerCaseFirstLetter(t('account:PRIVATE_EMAIL_FIELD'))
        })}
        label={t('account:PRIVATE_EMAIL_FIELD')}
        missing={missingFields?.includes('email')}
        missingMessage={t('employee:MISSING_FOR_COMPLETENESS')}
        name="email"
        xs={12}
      />
    </ProfileForm>
  );
};
